module.exports = __webpack_public_path__ + "static/mario-jump-b7b3c08ba649f69ed28b6cb349cafaa8.png";